import type { ComponentType } from 'react'
import { CartIcon, CardMultipleIcon, BellIcon, HomeIcon, MoreIcon } from '@/icons'

export interface NavTab {
  id: string
  label: string
  to: string
  icon: ComponentType<{ className?: string }>
}

export const TABS: NavTab[] = [
  { id: 'home', label: 'Home', to: '/', icon: HomeIcon },
  { id: 'browse', label: 'Browse', to: '/browse/cards', icon: CardMultipleIcon },
  { id: 'more', label: 'More', to: '', icon: MoreIcon },
]

export const MORE_LINKS: { label: string; to: string; icon: ComponentType<{ className?: string }> }[] = [
  { label: 'Buy/Sell', to: '/list/buy', icon: CartIcon },
  { label: 'Decks', to: '/decks', icon: CardMultipleIcon },
  { label: 'Binders', to: '/binders', icon: CardMultipleIcon },
  { label: 'Subscriptions', to: '/subscriptions', icon: BellIcon },
]

export function isTabActive(pathname: string, to: string) {
  if (to === '/') return pathname === '/'
  if (to === '/browse/cards') return pathname.startsWith('/browse')
  return pathname.startsWith(to)
}
